import {
  Injectable,
  ComponentFactoryResolver,
  ViewContainerRef,
  Injector,
} from "@angular/core";
import { TimePickerModalComponent } from "../../time-picker-modal/time-picker-modal.component";

@Injectable({
  providedIn: "root",
})
export class TimePickerModalService {
  /**
   * View container ref of time picker modal service
   */
  viewContainerRef: ViewContainerRef;
  /**
   * Creates an instance of time picker modal service.
   * @param componentFactoryResolver ComponentFactoryResolver
   */
  constructor(private componentFactoryResolver: ComponentFactoryResolver, private injector: Injector) {
    //
  }
  /**
   * Shows time picker modal service
   * @returns show
   */
  show(): Promise<any> {
    return new Promise((resolve) => {
      const factory = this.componentFactoryResolver.resolveComponentFactory(TimePickerModalComponent);
      const componentRef = this.viewContainerRef.createComponent(factory);
      const instance = <TimePickerModalComponent>componentRef.instance;
      instance.hidden = false;
      instance.closed.subscribe((res) => {
        if (componentRef) {
          componentRef.destroy();
        }
        resolve(res);
      });

    //   const factory = this.resolver.resolveComponentFactory(ModalComponent);
    //   const componentRef = factory.create(this.injector);

    //   componentRef.hostView.detectChanges();
    //   const { nativeElement } = componentRef.location;
    //   this.document.body.appendChild(nativeElement);
    });
  }
}
